import * as _ from "../../../../constants/Constants";
import * as rolePermConsts from "../../../../constants/RolePermissionConstants";

export const shippingAccordion = {
  eventKey: "0",
  accordionName: _.VENDORPLATFORM_MAIN_HEAD_SHIPPINGLOCATION,
  linkInfo: [
    // {
    //   path: (profileId) => `/boarding/routing`,
    //   linkName: _.VENDORPLATFORM_SUB_HEAD_ROUTING_REQUST_DETAILS,
    //   pageRoleId: rolePermConsts.VENDORPLATFORM_SHIPPING_LOCATIONDETAILS,
    // },
    {
      path: (profileId) => `/boarding/shipping`,
      linkName: _.VENDORPLATFORM_SUB_HEAD_LOCATIONDETAILS,
      pageRoleId: rolePermConsts.VENDORPLATFORM_SHIPPING_LOCATIONDETAILS,
    },
  ],
};
